export default __webpack_public_path__ + "static/media/ref-ctn-moszna.110d07fe.pdf";